export default __webpack_public_path__ + "static/media/impressions.70c3bce7.jpg";